module.exports = __webpack_public_path__ + "img/config.dd36f002.jpg";